// extracted by mini-css-extract-plugin
export var deleteIcon = "_pz-5";
export var deleteOption = "_pz-3";
export var divider = "_pz-2";
export var downloadIcon = "_pz-4";
export var drawer = "_pz-0";
export var drawerFooter = "_pz-6";
export var drawerOpen = "_pz-1";
export var highlighted = "_pz-7";
export var lighterHighlight = "_pz-8";